/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesMobileApplicationGroupsGroupResponse } from '../model/modulesMobileApplicationGroupsGroupResponse';
import { ModulesMobileApplicationLeaderboardsGetLeaderboardLeaderboardRowResponse } from '../model/modulesMobileApplicationLeaderboardsGetLeaderboardLeaderboardRowResponse';
import { ModulesMobileApplicationLeaderboardsGetMatchPlayLeaderboardMatchPlayLeaderboardRowResponse } from '../model/modulesMobileApplicationLeaderboardsGetMatchPlayLeaderboardMatchPlayLeaderboardRowResponse';
import { ModulesMobileApplicationLocationsPostGroupLocationPostGroupLocationRequest } from '../model/modulesMobileApplicationLocationsPostGroupLocationPostGroupLocationRequest';
import { ModulesMobileApplicationLocationsPostHoleLocationPostHoleLocationRequest } from '../model/modulesMobileApplicationLocationsPostHoleLocationPostHoleLocationRequest';
import { ModulesMobileApplicationNotificationsPostNotificationPostNotificationRequest } from '../model/modulesMobileApplicationNotificationsPostNotificationPostNotificationRequest';
import { ModulesMobileApplicationPlayersPlayerResponse } from '../model/modulesMobileApplicationPlayersPlayerResponse';
import { ModulesMobileApplicationSFPointsGetSFPointsSFPointsResponse } from '../model/modulesMobileApplicationSFPointsGetSFPointsSFPointsResponse';
import { ModulesMobileApplicationScoresScoreResponse } from '../model/modulesMobileApplicationScoresScoreResponse';
import { ModulesMobileApplicationTeamsGetGroupTeamsGroupTeamResponse } from '../model/modulesMobileApplicationTeamsGetGroupTeamsGroupTeamResponse';
import { ModulesMobileApplicationTournamentsGetTournamentCoursesTournamentCourseResponse } from '../model/modulesMobileApplicationTournamentsGetTournamentCoursesTournamentCourseResponse';
import { ModulesMobileApplicationTournamentsGetTournamentRoundsTournamentRoundResponse } from '../model/modulesMobileApplicationTournamentsGetTournamentRoundsTournamentRoundResponse';
import { ModulesMobileApplicationTournamentsGetTournamentsTournamentSummaryResponse } from '../model/modulesMobileApplicationTournamentsGetTournamentsTournamentSummaryResponse';
import { ModulesMobileEndpointsContractsScoresPostScoreRequestModel } from '../model/modulesMobileEndpointsContractsScoresPostScoreRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { MobileServiceInterface }                            from './mobile.serviceInterface';


@Injectable()
export class MobileService implements MobileServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a group by ID.
     * Gets a specific group by its identifier.
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGroupByIdMobileEndpoint(groupId: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesMobileApplicationGroupsGroupResponse>;
    public getGroupByIdMobileEndpoint(groupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesMobileApplicationGroupsGroupResponse>>;
    public getGroupByIdMobileEndpoint(groupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesMobileApplicationGroupsGroupResponse>>;
    public getGroupByIdMobileEndpoint(groupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling getGroupByIdMobileEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesMobileApplicationGroupsGroupResponse>('get',`${this.basePath}/mobile/groups/${encodeURIComponent(String(groupId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets players in a group.
     * Gets all players assigned to a specific group.
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGroupPlayersMobileEndpoint(groupId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationPlayersPlayerResponse>>;
    public getGroupPlayersMobileEndpoint(groupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationPlayersPlayerResponse>>>;
    public getGroupPlayersMobileEndpoint(groupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationPlayersPlayerResponse>>>;
    public getGroupPlayersMobileEndpoint(groupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling getGroupPlayersMobileEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationPlayersPlayerResponse>>('get',`${this.basePath}/mobile/groups/${encodeURIComponent(String(groupId))}/players`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets teams in a group.
     * Gets all teams assigned to a specific group.
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGroupTeamsMobileEndpoint(groupId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationTeamsGetGroupTeamsGroupTeamResponse>>;
    public getGroupTeamsMobileEndpoint(groupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationTeamsGetGroupTeamsGroupTeamResponse>>>;
    public getGroupTeamsMobileEndpoint(groupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationTeamsGetGroupTeamsGroupTeamResponse>>>;
    public getGroupTeamsMobileEndpoint(groupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling getGroupTeamsMobileEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationTeamsGetGroupTeamsGroupTeamResponse>>('get',`${this.basePath}/mobile/groups/${encodeURIComponent(String(groupId))}/teams`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets groups.
     * Gets groups with optional filtering by tournament, round, and course.
     * @param tournamentId 
     * @param roundId 
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGroupsMobileEndpoint(tournamentId?: number, roundId?: number, courseId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationGroupsGroupResponse>>;
    public getGroupsMobileEndpoint(tournamentId?: number, roundId?: number, courseId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationGroupsGroupResponse>>>;
    public getGroupsMobileEndpoint(tournamentId?: number, roundId?: number, courseId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationGroupsGroupResponse>>>;
    public getGroupsMobileEndpoint(tournamentId?: number, roundId?: number, courseId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }
        if (courseId !== undefined && courseId !== null) {
            queryParameters = queryParameters.set('CourseId', <any>courseId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationGroupsGroupResponse>>('get',`${this.basePath}/mobile/groups`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Health check endpoint.
     * Returns OK to indicate the mobile API is healthy.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHeartbeatMobileEndpoint(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getHeartbeatMobileEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getHeartbeatMobileEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getHeartbeatMobileEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/mobile/heartbeat`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets tournament leaderboards.
     * Gets the current tournament leaderboards for mobile display.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLeaderboardsMobileEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationLeaderboardsGetLeaderboardLeaderboardRowResponse>>;
    public getLeaderboardsMobileEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationLeaderboardsGetLeaderboardLeaderboardRowResponse>>>;
    public getLeaderboardsMobileEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationLeaderboardsGetLeaderboardLeaderboardRowResponse>>>;
    public getLeaderboardsMobileEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationLeaderboardsGetLeaderboardLeaderboardRowResponse>>('get',`${this.basePath}/mobile/leaderboards`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets match play tournament leaderboards.
     * Gets the current match play tournament leaderboards for mobile display, including match numbers, slot numbers, match status, and thru data.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMatchPlayLeaderboardsMobileEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationLeaderboardsGetMatchPlayLeaderboardMatchPlayLeaderboardRowResponse>>;
    public getMatchPlayLeaderboardsMobileEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationLeaderboardsGetMatchPlayLeaderboardMatchPlayLeaderboardRowResponse>>>;
    public getMatchPlayLeaderboardsMobileEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationLeaderboardsGetMatchPlayLeaderboardMatchPlayLeaderboardRowResponse>>>;
    public getMatchPlayLeaderboardsMobileEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationLeaderboardsGetMatchPlayLeaderboardMatchPlayLeaderboardRowResponse>>('get',`${this.basePath}/mobile/leaderboards/matchplay`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Stableford points configuration.
     * Gets the Stableford points system configuration.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSFPointsMobileEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationSFPointsGetSFPointsSFPointsResponse>>;
    public getSFPointsMobileEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationSFPointsGetSFPointsSFPointsResponse>>>;
    public getSFPointsMobileEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationSFPointsGetSFPointsSFPointsResponse>>>;
    public getSFPointsMobileEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationSFPointsGetSFPointsSFPointsResponse>>('get',`${this.basePath}/mobile/sfpoints`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets scores.
     * Gets scores with optional filtering by player and round.
     * @param playerId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScoresMobileEndpoint(playerId?: number, roundId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationScoresScoreResponse>>;
    public getScoresMobileEndpoint(playerId?: number, roundId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationScoresScoreResponse>>>;
    public getScoresMobileEndpoint(playerId?: number, roundId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationScoresScoreResponse>>>;
    public getScoresMobileEndpoint(playerId?: number, roundId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (playerId !== undefined && playerId !== null) {
            queryParameters = queryParameters.set('playerId', <any>playerId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationScoresScoreResponse>>('get',`${this.basePath}/mobile/scores`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets tournament courses.
     * Gets all courses for a specific tournament with optional round filtering.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentCoursesMobileEndpoint(tournamentId: number, roundId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationTournamentsGetTournamentCoursesTournamentCourseResponse>>;
    public getTournamentCoursesMobileEndpoint(tournamentId: number, roundId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationTournamentsGetTournamentCoursesTournamentCourseResponse>>>;
    public getTournamentCoursesMobileEndpoint(tournamentId: number, roundId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationTournamentsGetTournamentCoursesTournamentCourseResponse>>>;
    public getTournamentCoursesMobileEndpoint(tournamentId: number, roundId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentCoursesMobileEndpoint.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationTournamentsGetTournamentCoursesTournamentCourseResponse>>('get',`${this.basePath}/mobile/tournaments/${encodeURIComponent(String(tournamentId))}/courses`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets tournament rounds.
     * Gets all rounds for a specific tournament.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentRoundsMobileEndpoint(tournamentId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationTournamentsGetTournamentRoundsTournamentRoundResponse>>;
    public getTournamentRoundsMobileEndpoint(tournamentId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationTournamentsGetTournamentRoundsTournamentRoundResponse>>>;
    public getTournamentRoundsMobileEndpoint(tournamentId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationTournamentsGetTournamentRoundsTournamentRoundResponse>>>;
    public getTournamentRoundsMobileEndpoint(tournamentId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentRoundsMobileEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationTournamentsGetTournamentRoundsTournamentRoundResponse>>('get',`${this.basePath}/mobile/tournaments/${encodeURIComponent(String(tournamentId))}/rounds`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all tournaments.
     * Gets all available tournaments with basic information.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentsMobileEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesMobileApplicationTournamentsGetTournamentsTournamentSummaryResponse>>;
    public getTournamentsMobileEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesMobileApplicationTournamentsGetTournamentsTournamentSummaryResponse>>>;
    public getTournamentsMobileEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesMobileApplicationTournamentsGetTournamentsTournamentSummaryResponse>>>;
    public getTournamentsMobileEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesMobileApplicationTournamentsGetTournamentsTournamentSummaryResponse>>('get',`${this.basePath}/mobile/tournaments`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Submits group location.
     * Submits location data for a group.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postGroupLocationMobileEndpoint(body?: ModulesMobileApplicationLocationsPostGroupLocationPostGroupLocationRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public postGroupLocationMobileEndpoint(body?: ModulesMobileApplicationLocationsPostGroupLocationPostGroupLocationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public postGroupLocationMobileEndpoint(body?: ModulesMobileApplicationLocationsPostGroupLocationPostGroupLocationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public postGroupLocationMobileEndpoint(body?: ModulesMobileApplicationLocationsPostGroupLocationPostGroupLocationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/mobile/locations`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Submits hole location.
     * Submits location data for a hole (pin position).
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postHoleLocationMobileEndpoint(body?: ModulesMobileApplicationLocationsPostHoleLocationPostHoleLocationRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postHoleLocationMobileEndpoint(body?: ModulesMobileApplicationLocationsPostHoleLocationPostHoleLocationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postHoleLocationMobileEndpoint(body?: ModulesMobileApplicationLocationsPostHoleLocationPostHoleLocationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postHoleLocationMobileEndpoint(body?: ModulesMobileApplicationLocationsPostHoleLocationPostHoleLocationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/mobile/holes`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sends a notification.
     * Sends a notification message.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postNotificationMobileEndpoint(body?: ModulesMobileApplicationNotificationsPostNotificationPostNotificationRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postNotificationMobileEndpoint(body?: ModulesMobileApplicationNotificationsPostNotificationPostNotificationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postNotificationMobileEndpoint(body?: ModulesMobileApplicationNotificationsPostNotificationPostNotificationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postNotificationMobileEndpoint(body?: ModulesMobileApplicationNotificationsPostNotificationPostNotificationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/mobile/notifications`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Submits a score.
     * Submits a score for a player on a specific hole.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postScoreEndpoint(body?: ModulesMobileEndpointsContractsScoresPostScoreRequestModel, observe?: 'body', reportProgress?: boolean): Observable<ModulesMobileEndpointsContractsScoresPostScoreRequestModel>;
    public postScoreEndpoint(body?: ModulesMobileEndpointsContractsScoresPostScoreRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesMobileEndpointsContractsScoresPostScoreRequestModel>>;
    public postScoreEndpoint(body?: ModulesMobileEndpointsContractsScoresPostScoreRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesMobileEndpointsContractsScoresPostScoreRequestModel>>;
    public postScoreEndpoint(body?: ModulesMobileEndpointsContractsScoresPostScoreRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ModulesMobileEndpointsContractsScoresPostScoreRequestModel>('post',`${this.basePath}/mobile/scores`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
